import { render } from "./FORUM_UPDATE_COVER.vue?vue&type=template&id=ef690cf4"
import script from "./FORUM_UPDATE_COVER.vue?vue&type=script&lang=js"
export * from "./FORUM_UPDATE_COVER.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__